export const ADVISORY_ENGAGEMENT_IDS = [
  'ai-digital-transformation',
  'business-and-performance-review',
  'business-portfolio-strategy',
  'cash-liquidity-and-financing',
  'commercial-marketing-and-pricing',
  'competitor-analysis',
  'corporate-and-portfolio-strategy',
  'cost-and-margin',
  'eu-compliance-and-data-protection',
  'future-trends',
  'growth-strategy',
  'investment-m-and-a-decision',
  'new-business-models',
  'operations-and-supply-chain-excellence',
  'organization-operating-model-and-talent',
  'planning-and-budget',
  'restructuring-and-turnaround',
  'risk-and-early-warning',
  'scenario-planning',
  'sustainability-and-esg-strategy',
  'value-and-transformation-plan',
] as const;

export const ADVISORY_QUESTION_IDS = [
  'adaptive-response',
  'adoption-roadmap',
  'adversarial-stress-test',
  'ai-opportunity-scan',
  'assumption-register',
  'balance-cost-vs-profitability-scenarios',
  'balance-longterm-investment-shortterm-delivery',
  'best-org-model',
  'biz-health',
  'brand-positioning',
  'business-model-fit',
  'capital-allocation',
  'capital-invested-supply-chain',
  'cash-return-on-invested-capital',
  'commercial-sales-effectiveness',
  'competitive-durability',
  'competitors-attack-collaborate-acquire',
  'compliance-remediation-roadmap',
  'cost-reduction',
  'cost-structure',
  'covenant-risk',
  'culture-change-readiness',
  'customer-segment-value',
  'data-ip-risk-exposure',
  'decarbonization-path',
  'earnings-quality',
  'emerging-risks',
  'escalation',
  'esg',
  'esg-compliance-readiness',
  'eu-ai-act-classification',
  'eu-regulatory-perimeter',
  'execution-risk-ownership',
  'financing-options',
  'fix-cut-close-sell-options',
  'foresight-action-portfolio',
  'gdpr-data-protection-readiness',
  'geopolitical-changes-supply-chain',
  'go-no-go',
  'integration-plan',
  'leading-indicators',
  'legal-regulatory-exposure',
  'lever-attractiveness-after-risk',
  'leverage-esg-regulations-in-regions',
  'margin-leakage',
  'market-attractiveness',
  'market-durability',
  'marketing-mix-efficiency',
  'mitigations',
  'nbm-adapt',
  'nbm-combine',
  'nbm-company-profile',
  'nbm-compare',
  'nbm-deep-dive',
  'nbm-match',
  'nbm-partners',
  'nbm-realize',
  'operating-cost-ai-solution',
  'ops-improvement-levers',
  'ops-performance-diagnosis',
  'option-impact-tradeoffs',
  'org-operating-model-fit',
  'outlook',
  'parenting-advantage',
  'plan-tradeoffs',
  'portfolio-composition',
  'portfolio-products-right-one',
  'portfolio-rollup',
  'possible-decarbonisation-technologies',
  'pricing-revenue',
  'resource-alloc',
  'right-price-per-product-customer',
  'right-to-win',
  'scenario-construction',
  'scenario-framing',
  'scenario-impact',
  'scenario-signposts',
  'scenario-synthesis',
  'screening-rank',
  'signals-and-drivers',
  'stranded-cost-dissynergy',
  'strategic-relevance',
  'strategic-synthesis',
  'succession-plan-manager-leaves',
  'supply-chain-resilience',
  'sustainability-value',
  'talent-capability-gap',
  'targets',
  'tax-structuring',
  'trend-confidence-and-adoption',
  'trend-scan-framing',
  'underperformance-diagnosis',
  'valuation-synergies',
  'value-bridge-linkage',
  'value-lever-sequencing',
  'variance',
] as const;

export const ADVISORY_COMPOSITE_IDS = [
  'ActionPriorityBoard',
  'BrandPositioningBoard',
  'BusinessModelBoard',
  'CompanyProfile',
  'ComparisonBoard',
  'DealEconomicsBoard',
  'DecisionBrief',
  'DemandEfficiencyBoard',
  'DurabilityBoard',
  'ESGMaterialityBoard',
  'EvidenceReadinessRegister',
  'FinancialModelBoard',
  'MarketOpportunityBoard',
  'OptionSelectionBoard',
  'PartnerBoard',
  'PeopleCapabilityBoard',
  'PerformanceReview',
  'PortfolioBoard',
  'RiskExposureBoard',
  'RoadmapBoard',
  'SensitivityBoard',
  'StressScenarioBoard',
  'SystemGovernanceMap',
  'ValueBridgeBoard',
] as const;

export const ADVISORY_COMPONENT_IDS = [
  'action-priority',
  'business-model-canvas',
  'comparison-matrix',
  'counter-position',
  'decision',
  'durability-factors',
  'evidence-table',
  'financial-forecast',
  'market-sizing',
  'metric-strip',
  'narrative',
  'options-matrix',
  'people-grid',
  'portfolio-matrix',
  'risk-matrix',
  'roadmap-timeline',
  'scenario-matrix',
  'sensitivity-plot',
  'system-map',
  'value-bridge',
] as const;

export type AdvisoryEngagementId = (typeof ADVISORY_ENGAGEMENT_IDS)[number];
export type AdvisoryQuestionId = (typeof ADVISORY_QUESTION_IDS)[number];
export type AdvisoryCompositeId = (typeof ADVISORY_COMPOSITE_IDS)[number];
export type AdvisoryComponentId = (typeof ADVISORY_COMPONENT_IDS)[number];
